import React from "react";
import { node, bool } from "prop-types";
import { Col } from "../Grid";
import Block from "../Block";
import NavbarToggleButton from "../Navbar/ToggleButton";
import { useHeader } from "./context";

const HeaderToggle = ({ children, withToggle = true }) => {
	const { isOpen, onToggle } = useHeader();
	return (
		<Col className="navbar__header" lg="shrink">
			<Block utility={{ display: "flex", justify: "between", align: { items: "center" } }}>
				<div className="header__logo">{children}</div>
				{withToggle && <NavbarToggleButton onClick={onToggle} isOpen={isOpen} />}
			</Block>
		</Col>
	);
};

HeaderToggle.propTypes = {
	children: node.isRequired,
	withToggle: bool,
};

export default HeaderToggle;
